import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';
import { useOrgKey } from '@/hooks/auth/useOrgKey';

// `scope: 'org'` forces server-side org scoping so platform admins viewing
// the active org see only that org's members in member-picker UIs (e.g. the
// agents-list Owner filter), not every user across every organization.
export function useUsers() {
  const orgKey = useOrgKey();
  return useQuery({
    queryKey: queryKeys.users(orgKey),
    queryFn: () => api.listUsers({ scope: 'org' }),
  });
}
